import { TableHeader, TableHeaderDefs, TableHeaderDefsRow } from '../../types';
import { allocationHeader, isSpecialHeader } from '../special-headers';

export class RowspanBuilder {
  public buildRowspans(headerDefs: TableHeaderDefs): void {
    if (headerDefs.length === 0) {
      return;
    }

    const columnCount = headerDefs[0].length;
    const rowCount = headerDefs.length;

    for (let rowIndex = 0; rowIndex < rowCount; rowIndex++) {
      const row: TableHeaderDefsRow = headerDefs[rowIndex];

      for (let columnIndex = 0; columnIndex < columnCount; columnIndex++) {
        const header = row[columnIndex];

        if (!header || header.colspan === 0) {
          continue;
        }

        this.calculateCellRowspanFromEmptySpaceBelow(rowIndex, columnIndex, headerDefs);
      }
    }
  }

  private calculateCellRowspanFromEmptySpaceBelow(
    rowIndex: number,
    colIndex: number,
    headerDefs: TableHeaderDefs
  ): void {
    const rowCount: number = headerDefs.length;
    const header: TableHeader = headerDefs[rowIndex][colIndex];

    if (isSpecialHeader(header)) {
      return;
    }

    const colspan = header.colspan ?? 1;
    header.rowspan = 1;

    for (let lowerRowIndex = rowIndex + 1; lowerRowIndex < rowCount; lowerRowIndex++) {
      const row: TableHeaderDefsRow = headerDefs[lowerRowIndex];

      if (this.hasAnyCellNotNullInRow(row, colIndex, colspan)) {
        break;
      }

      for (let span = 0; span < colspan; span++) {
        headerDefs[lowerRowIndex][colIndex + span] = allocationHeader;
      }

      header.rowspan = header.rowspan + 1;
    }
  }

  private hasAnyCellNotNullInRow(row: TableHeaderDefsRow, columnIndex: number, colspan: number): boolean {
    for (let span = 0; span < colspan; span++) {
      const cell: TableHeader = row[columnIndex + span];
      if (cell) {
        return true;
      }
    }
    return false;
  }
}
